import CardMapLayout from './CardMapLayout';

export default CardMapLayout;
